'use strict';

var cache = {};

module.exports = {
    initMaskPasswordCache: function () {
        cache.$passwordBtn = $('.hide-show-password');
        cache.$formsInput = $('.password-input');
        cache.$eyeIconOpen = '.fa-eye';
        cache.$eyeIconClosed = 'fa-eye-slash';
        cache.$passwordActive = 'show-password-active';
    },
    toggleShowHide: function () {
        //accessibility for enter button on keyboard
        cache.$passwordBtn.on('keyup', function (event) {
            if (event.which == 13) {
                var $this = $(this);

                $this.trigger('click');
                $this.focus();
            }
        });
        cache.$passwordBtn.on('click', function () {
            var $this = $(this);
            $this.attr('aria-pressed', function (_, attr) {
                return attr === 'true' ? 'false' : 'true';
            }).attr('aria-expanded', function (_, attr) {
                return attr === 'true' ? 'false' : 'true';
            }).attr('aria-label', function (_, attr) {
                return attr === 'Show password' ? 'Hide password' : 'Show password';
            });
            var $formInput = $this.parent().find(cache.$formsInput);
            $this.find(cache.$eyeIconOpen).toggleClass(cache.$eyeIconClosed);

            $formInput.toggleClass(cache.$passwordActive);
            $formInput.prop('type', $formInput.hasClass(cache.$passwordActive) ? 'text' : 'password');
        });
    }
};
